export interface WorkItem {
    company: string;
    description: string;
    role: string;
    technologies: string;
}

interface TimeLinePieceProps {
    work: WorkItem;
}

const TimeLinePiece = ({ work }: TimeLinePieceProps) => (
    <div className='row'>
        <div className='col-sm-4 timeLineHeading'>
            <div className='experienceHeading'>
                <span className='timeLineDot' />
                <p>{work.role}</p>
            </div>
        </div>
        <div className='col-sm-8'>
            <div className='experienceContainer'>
                <h4>{work.company}</h4>
                <p>{work.description}</p>
                <p className='technologies'>{work.technologies}</p>
            </div>
        </div>
    </div>
);

export default TimeLinePiece;
